module.exports = __webpack_public_path__ + "media/images/icons/material/euro-symbol-53c9f7ec79fcc0c856b5836ddcde9126.svg";